// Template Registry - Shared configuration for EU Landing Page Engine
import TemplateMadrid from './TemplateMadrid';
import TemplateBarcelona from './TemplateBarcelona';

// Template components mapping
export const TEMPLATES = {
  madrid: TemplateMadrid,
  barcelona: TemplateBarcelona
};

// Template metadata for UI
export const TEMPLATE_INFO = {
  madrid: {
    id: 'madrid',
    name: 'Madrid',
    description: 'Clean, profesional, comercial',
    style: 'Corporativo',
    primaryColor: '#1e40af',
    features: ['Header limpo', 'Hero com CTA forte', 'Grid de serviços', 'Galeria minimalista'],
    bestFor: ['Electricistas', 'Fontaneros', 'Reformas', 'Consultores']
  },
  barcelona: {
    id: 'barcelona',
    name: 'Barcelona',
    description: 'Moderno, assimétrico, fotografia forte',
    style: 'Moderno',
    primaryColor: '#dc2626',
    features: ['Layout assimétrico', 'Fotografia em destaque', 'Tipografia bold', 'Animações suaves'],
    bestFor: ['Fotógrafos', 'Designers', 'Arquitetos', 'Criativos']
  }
};

// Get template component by ID
export const getTemplateComponent = (templateId) => {
  return TEMPLATES[templateId] || TEMPLATES.madrid;
};

// Get template info by ID
export const getTemplateInfo = (templateId) => {
  return TEMPLATE_INFO[templateId] || TEMPLATE_INFO.madrid;
};

// List of available template IDs
export const getAvailableTemplateIds = () => Object.keys(TEMPLATES);

export default TEMPLATES;
